import React from "react";
import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepPayment from "components/Step/StepPayment";
import { useFall25ExtCouponSync } from "utils/hooks/useFall25ExtCouponSync";

export const MembershipStepPayment = ({
  phoneNumber,
  routePrevStep,
  ...stepProps
}: MembershipState) => {
  useFall25ExtCouponSync();

  const backButtonProps = {
    onClick: () => routePrevStep?.(),
  };

  return (
    <StepPayment
      {...stepProps}
      phoneNumber={phoneNumber}
      stepFooterProps={{ backButtonProps }}
      stepHeaderProps={{ backButtonProps }}
    />
  );
};

export const MEMBERSHIP_STEP_PAYMENT: MembershipStep = {
  component: MembershipStepPayment,
  id: "membership-id-payment",
  slug: "payment",
};

export default MembershipStepPayment;
